import { Image } from 'expo-image';
import * as Location from 'expo-location';
import { router, useLocalSearchParams } from 'expo-router';
import { useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

import { useNpoOnboarding } from '@/api/hooks/meHooks';
import { location } from '@/assets/images';
import BrandedButton from '@/components/buttons/BrandedButton';
import Text from '@/components/Text';
import { SIGN_IN_BUTTON_BOTTOM } from '@/constants/layout';
import { useAuth } from '@/contexts/authContext';
import { useColor } from '@/hooks/useColor';
import { i18n } from '@/utils/i18n';

const LocationScreen = () => {
  const { state } = useAuth();
  const { mutateAsync: onBoardingUpdate, isPending } = useNpoOnboarding(state.signUpData?.loginEmail?.type ?? 'CHURCH');
  const { from, buyingShow } = useLocalSearchParams<{ from: string; buyingShow: string }>();

  const colors = useColor();
  const [isLoading, setIsLoading] = useState(false);

  const titleText = i18n.t('sign_in.location.title');
  const descriptionText = i18n.t('sign_in.location.description');
  const buttonText = i18n.t('sign_in.location.button');

  const onPress = async () => {
    setIsLoading(true);
    try {
      await Location.requestForegroundPermissionsAsync();
      if (from === 'individual') {
        router.dismissAll();
        if (buyingShow === 'true') {
          router.navigate('/home/npoTabs');
          router.navigate('/(app)/purchaseShow');
        } else {
          router.navigate('/home/npoTabs');
        }
      } else if (from === 'nonProfit') {
        onBoardingUpdate(
          {
            preferenceId: state.preferenceId ?? '',
            isSetLocationScreen: true
          },
          {
            onSuccess: () => {
              router.replace('/login/nonProfit/intro');
            }
          }
        );
      }
    } catch (e) {
      console.error('Error requesting location permission', e);
      setIsLoading(false);
    }
  };

  return (
    <SafeAreaView style={styles.container}>
      <View style={styles.contentWrapper}>
        <Text style={[styles.titleText, { color: colors.titleText }]} fontWeight="700">
          {titleText}
        </Text>
        <View style={styles.imageContainer}>
          <Image source={location} style={styles.image} contentFit="contain" />
        </View>
        <Text style={styles.descriptionText}>{descriptionText}</Text>
      </View>
      <BrandedButton loading={isLoading || isPending} style={styles.btnStyle} onPress={onPress}>
        {buttonText}
      </BrandedButton>
    </SafeAreaView>
  );
};

export default LocationScreen;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    marginHorizontal: 16
  },
  contentWrapper: {
    flex: 1,
    alignItems: 'center'
  },
  titleText: {
    fontSize: 22,
    marginBottom: 26,
    textAlign: 'center',
    marginTop: 142
  },
  imageContainer: {
    marginBottom: 25,
    paddingVertical: 11
  },
  image: {
    height: 123,
    width: 123
  },
  descriptionText: {
    textAlign: 'center'
  },
  btnStyle: {
    width: '100%',
    marginBottom: SIGN_IN_BUTTON_BOTTOM
  },
  btnLabel: {
    fontSize: 14
  }
});
